import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { getGroupsAsync, getGroupsTreeFormAsync, getGroupsStyleAsync } from './asyncActions';


export const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGroupsAsync.pending, (state) => {
        state.groupLists.status = 'loading';
      })
      .addCase(getGroupsAsync.fulfilled, (state, action) => {
        state.groupLists.status = 'idle';
        state.groupLists.data = action.payload?.items;
      })
      .addCase(getGroupsAsync.rejected, (state) => {
        state.groupLists.status = 'failed';
      })
      .addCase(getGroupsTreeFormAsync.pending, (state) => {
        state.groupsTree.status = 'loading';
      })
      .addCase(getGroupsTreeFormAsync.fulfilled, (state, action) => {
        state.groupsTree.status = 'idle';
        state.groupsTree.data = action.payload?.item;
      })
      .addCase(getGroupsTreeFormAsync.rejected, (state) => {
        state.groupsTree.status = 'failed';
      })
      .addCase(getGroupsStyleAsync.fulfilled, (state, action) => {
        state.groupsStyle = action.payload?.item;
      })
  },
});

export default groupsSlice.reducer;
